module.exports = {
  // fake rapid spaceid
  rapid: {
    spaceid: '987654321'
  },
  ga: {
    cookieDomain: 'tw.supplier.yahoo.com',
    trackingId: 'UA-103553390-1',
    sampleRate: 100
  },
  gaDev: {
    trackingId: 'UA-137972684-1',
    sampleRate: 100
  }
}
